import React from 'react';
import { Modal, FormGroup, ControlLabel, FormControl, Button, Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const CreateSkillGroupModal = ({show, hide, data, updated, submitted}) => {
    return (
        <Modal show={show} onHide={hide}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Skill Group</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form horizontal onSubmit={submitted}>

                    {formTextField('Skill Group Name', 'Phonemeic Awareness, e.g., MySkillGroupName', updated, data.skillGroupNameValidation)}
                    {renderButton(data.isRequesting, data.isFormValid)}

                </Form>
            </Modal.Body>
        </Modal>
    );
};

const renderButton = (isRequesting, isFormValid) =>
{
    if(isRequesting)
    {
        return( 
            <Button type="submit" style={{backgroundColor:'blue', color: 'white'}} block disabled={isRequesting}>Creating...</Button>
        );
    }
    else
    {
        return(
            <Button type="submit" bsStyle="success" block disabled={isFormValid && !isRequesting}>Create</Button>            
        )
    }
}

const formTextField = (label, placeholder, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl type='text' name={label} placeholder={placeholder} onChange={onChange} />
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

CreateSkillGroupModal.propTypes = {
    show:       PropTypes.bool.isRequired,
    hide:       PropTypes.func.isRequired,
    data:       PropTypes.object.isRequired,
    updated:    PropTypes.func.isRequired,
    submitted:  PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/createSkillGroupModal/CreateSkillGroupModal.js